"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _material = require("@mui/material");
var _Hidden = _interopRequireDefault(require("../Hidden"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _ArrowForward = _interopRequireDefault(require("@mui/icons-material/ArrowForward"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _url = require("../../utils/url");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _makeStyles["default"])(function (theme) {
  return {
    img: {
      maxWidth: "100%",
      borderRadius: theme.shape.borderRadius
    },
    listItem: {
      paddingLeft: 0,
      paddingRight: 0
    }
  };
});
var LocationRow = function LocationRow(_ref) {
  var location = _ref.location;
  var _useStyles = useStyles(),
    listItem = _useStyles.listItem;
  var boatsAvailable = (0, _react.useMemo)(function () {
    var boats = (location.boats || []).filter(function (b) {
      return !b.archived;
    });
    return location.calculatedBoatCount && location.calculatedBoatCount > 0 ? location.calculatedBoatCount : boats && boats.length > 0 ? boats.length : 0;
  });
  return /*#__PURE__*/_react["default"].createElement(_material.ListItem, {
    dense: true,
    button: true,
    color: "primary",
    className: listItem
  }, /*#__PURE__*/_react["default"].createElement(_material.ListItemText, {
    primary: /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      variant: "body1",
      component: "li",
      color: "primary"
    }, location.name, " ", /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      component: "span",
      color: "textSecondary",
      variant: "body2"
    }, "(", boatsAvailable, " ", boatsAvailable === 1 ? "Boat" : "Boats", " ", "available)"))
  }), /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_ArrowForward["default"], {
    color: "primary"
  })));
};
function LocationsSection(_ref2) {
  var locations = _ref2.locations,
    LinkComponent = _ref2.LinkComponent,
    image = _ref2.image,
    count = _ref2.count;
  var _useStyles2 = useStyles(),
    img = _useStyles2.img;
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    spacing: 10
  }, image && /*#__PURE__*/_react["default"].createElement(_Hidden["default"], {
    smDown: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    sm: 6
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: img,
    src: image,
    alt: "Map"
  }))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react["default"].createElement(_Hidden["default"], {
    smDown: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "h6",
    color: "textSecondary"
  }, "We have ", count, " boat hire options within ", locations.length, " regions."), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "h6",
    gutterBottom: true,
    color: "textSecondary"
  }, "Select a location to find our ideal boating experience.")), /*#__PURE__*/_react["default"].createElement(_material.List, null, locations.map(function (location, i) {
    return /*#__PURE__*/_react["default"].createElement(LinkComponent, {
      key: i,
      to: location.landingPages && location.landingPages.length > 0 && location.landingPages[0].path ? location.landingPages[0].path : (0, _url.locationPagePath)(location.name)
    }, /*#__PURE__*/_react["default"].createElement(LocationRow, {
      location: location
    }));
  }))));
}
LocationsSection.propTypes = {
  LinkComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  image: _propTypes["default"].string,
  locations: _propTypes["default"].arrayOf(_propTypes["default"].object)
};
LocationsSection.defaultProps = {
  locations: []
};
var _default = exports["default"] = LocationsSection;